(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target instanceof Element
    ? event.target.closest('a[href="#shopifyReshowConsentBanner"]')
    : null;
  if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const popover = link.closest('[popover]');
  if (popover?.matches(':popover-open')) popover.hidePopover();
  window.privacyBanner.showPreferences().catch(() => {
    window.location.hash = 'shopifyReshowConsentBanner';
  });
}, true);
  } catch(e) { console.error(e); }
})();

})();
